var _clipPath;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotVisitedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icons__not-visited-icon",
    width: "100%",
    height: "100%",
    viewBox: "0 0 1000 1000",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1000,
    height: 1000,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1000,
    height: 1000
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.21265,0,0,1.21265,-80.6324,-128.063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M891.134,311.767C891.134,197.984 798.757,105.606 684.974,105.606L272.653,105.606C158.87,105.606 66.493,197.984 66.493,311.767L66.493,724.087C66.493,837.87 158.87,930.248 272.653,930.248L684.974,930.248C798.757,930.248 891.134,837.87 891.134,724.087L891.134,311.767Z",
    style: {
      fill: "rgb(217,217,217)"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotVisitedIcon);
export default __webpack_public_path__ + "static/media/not-visited-icon.9c7adc2cb6d05da3e36ff8de889bc82e.svg";
export { ForwardRef as ReactComponent };